// QR Kiosk v2 — KV2-2 skeletons (bug #13 convention: 1:1 mirrors, SkeletonBlock
// only, no entrance animation). ReportsListSkeleton mirrors the rows-card region
// only (title + tabs render real). ReportDetailSkeleton mirrors the unconditional
// detail card (header + meta grid + description; no actions — those are status-gated).
import React from "react";
import { SkeletonBlock } from "../shared/SkeletonBlocks";

export function ReportsListSkeleton() {
  return (
    <div
      style={{
        margin: "12px 14px 0",
        border: "1px solid var(--border)",
        borderRadius: 12,
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{ padding: "12px 14px", borderTop: i === 0 ? "none" : "1px solid var(--border-soft)" }}
        >
          <SkeletonBlock w={90} h={10} />
          <SkeletonBlock w="75%" h={13} style={{ marginTop: 6 }} />
          <SkeletonBlock w={130} h={9} style={{ marginTop: 6 }} />
        </div>
      ))}
    </div>
  );
}

export function ReportDetailSkeleton() {
  return (
    <div
      style={{
        margin: "14px 14px 0",
        background: "var(--card)",
        border: "1px solid var(--border)",
        borderRadius: 12,
        boxShadow: "var(--shadow)",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {/* header */}
      <div style={{ padding: "14px 16px 12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <SkeletonBlock w={90} h={11} />
          <span style={{ flex: 1 }} />
          <SkeletonBlock w={70} h={24} r={999} />
        </div>
        <SkeletonBlock w="80%" h={16} style={{ marginTop: 9 }} />
      </div>

      {/* meta grid — exactly 4 cells */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: 14,
          padding: "2px 16px 6px",
          borderTop: "1px solid var(--border-soft)",
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <div key={i} style={{ padding: "9px 0" }}>
            <SkeletonBlock w={50} h={8} />
            <SkeletonBlock w="70%" h={12} style={{ marginTop: 4 }} />
          </div>
        ))}
      </div>

      {/* description */}
      <div style={{ padding: "10px 16px 14px", borderTop: "1px solid var(--border-soft)" }}>
        <SkeletonBlock w={110} h={8} />
        <SkeletonBlock w="100%" h={11} style={{ marginTop: 7 }} />
        <SkeletonBlock w="85%" h={11} style={{ marginTop: 5 }} />
      </div>
    </div>
  );
}

// KV2-3 additive: 1:1 mirror of the loaded form region (bug #13 convention). Used by
// edit-mode report fetch (§4.2) and solve deep-link fetch (§5.2).
export function FormSkeleton() {
  return (
    <div style={{ padding: "12px 16px 0", display: "flex", flexDirection: "column", gap: 14, flexShrink: 0 }}>
      {[0, 1, 2].map((i) => (
        <div key={i}>
          <SkeletonBlock w={120} h={10} />
          <SkeletonBlock w="100%" h={48} r={11} style={{ marginTop: 6 }} />
        </div>
      ))}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
        {[0, 1, 2].map((i) => (
          <SkeletonBlock key={i} w="100%" h={84} r={11} />
        ))}
      </div>
      <SkeletonBlock w="100%" h={56} r={13} style={{ marginTop: 16 }} />
    </div>
  );
}
